import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRightCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.58789 9.00178C1.58789 13.0934 4.90859 16.4141 9.00017 16.4141C13.0918 16.4141 16.4125 13.0934 16.4125 9.00178C16.4125 4.9102 13.0917 1.5895 9.00017 1.5895C4.90859 1.5895 1.58789 4.9102 1.58789 9.00178ZM8.78521 6.19253L11.0682 8.47551C11.3573 8.76459 11.3573 9.23156 11.0682 9.52805L8.78521 11.811C8.49614 12.1001 8.02175 12.1001 7.73267 11.811C7.44359 11.522 7.44359 11.055 7.73267 10.7659L9.49679 9.00178L7.73267 7.23766C7.44359 6.94858 7.44359 6.48161 7.73267 6.19253C8.02175 5.90345 8.49614 5.90345 8.78521 6.19253Z",
		fill: "currentColor"
	})
});
export default SvgChevronRightCircle;
